
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruit/jobs",
      function () {
        return require("private-next-pages/recruit/jobs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruit/jobs"])
      });
    }
  